// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-details-popup>.el-dialog{margin-top:calc(50vh - 308px)!important;height:616px}.widget-details-popup>.el-dialog>.el-dialog__header{padding:0}.widget-details-popup>.el-dialog>.el-dialog__header .el-dialog__headerbtn{z-index:10}.widget-details-popup>.el-dialog>.el-dialog__body{padding:0}.widget-details-popup>.el-dialog>.el-dialog__body>section{position:absolute;top:0;bottom:0;width:912px}", ""]);
// Exports
module.exports = exports;
